import Splide from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

class SplideScrollerInit {
  constructor() {
    this.play()
  }

  play() {
    const splides = document.querySelectorAll('.brands-mobile__container-outer.splide')
    splides.forEach(splide => {
      new Splide(splide, {
        type: 'loop',
        focus: 'center',
        gap: '1rem',
        drag: true,
        direction: 'ltr',
        arrows: false,
        pagination: false,
        autoScroll: {
          speed: .5,
        },
        perPage: 3,
      }).mount({AutoScroll});
    })
  }
}

export default SplideScrollerInit
